/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class InfoEventController {
    public static $inject = [
        '$uibModalInstance',
        'event'
    ];

    constructor(private $uibModalInstance: any, private event: IEvent) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
}

angular.module('beneple.calendar').controller('InfoEventController', InfoEventController);



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/info-event.controller.ts